module.exports = __webpack_public_path__ + "media/icons/bar-chart-trend-up-463624f5.png";